import FAQArticle from "../models/FAQArticle";

export default class FAQArticleMapper {
    public map(data: any) : FAQArticle {
        const faqArticle : FAQArticle = new FAQArticle();
        faqArticle.answer = data.Answer;
        faqArticle.question = data.Question;
        
        return faqArticle;
    }
}